import React from 'react';
import { createRoot } from 'react-dom/client';
import { Router } from './routes';
import { ThemeContextProvider } from './contexts/themeContext';

const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <ThemeContextProvider>
      <Router />
    </ThemeContextProvider>
  </React.StrictMode>
);
